import React, { useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Navigation } from "lucide-react";
import LiveDriverMap from "@/components/LiveDriverMap";

export default function LiveDriverMapDialog({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl rounded-sm" data-testid="live-driver-map-dialog">
        <DialogHeader>
          <DialogTitle className="font-display flex items-center gap-2">
            <Navigation className="w-4 h-4 text-primary" /> Live driver map
          </DialogTitle>
          <DialogDescription>Real-time positions of drivers on the road.</DialogDescription>
        </DialogHeader>
        {open && <LiveDriverMap heightClass="h-[55vh] sm:h-[60vh]" />}
      </DialogContent>
    </Dialog>
  );
}
